import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';

const DialogImage = ( { title, subTitle, image }) => {
    const [opend, setOpend] = React.useState(true);
    /* const handleClickOpen = () => {
        setOpen(true);
    }; */
    // let img = 'https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif'
    const ImgPresent = (image) => <img src={`${image}`} alt='some value'/>
    const handleClose = () => {
        setOpend(false);
    };
    const handleCloseCobrar = (str) => {
        // handleQR(str)
        setOpend(false);
    };
    return (
        <Dialog
            open={opend}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{ title }</DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
                { ImgPresent(image) }
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} color="primary" style={{borderLeft: '3px solid rgba(255, 198, 0)'}}>
                Cancelar
            </Button>
            <Button onClick={() => {handleCloseCobrar('aceptar')}} color="primary" autoFocus style={{borderLeft: '3px solid rgba(255, 198, 0)'}}>
                Aceptar
            </Button>
            </DialogActions>
      </Dialog>
    );
};

DialogImage.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
}

export default DialogImage;